import Vue from 'vue'

/**
 * 货币单位
 * @param unit 货币类型
 */
Vue.filter('unitFormat', function (unit) {
  if (typeof unit !== 'undefined') {
    let u
    switch (unit) {
      case 'MYR':
        u = 'RM'
        break
      case 'CNY':
        u = '￥'
        break
      case 'SGD':
        u = '$'
        break
      case 'USD':
        u = '$'
        break
    }
    return u
  }
})

/**
 * 订单状态
 * @param status 状态类型
 */
Vue.filter('statusFormat', function (status) {
  if (typeof status !== 'undefined') {
    let s
    switch (status) {
      case 'Paid':
        s = 'In Processing'
        break
      case 'Complete':
        s = 'Not Gifted'
        break
      case 'Transferred':
        s = 'Gifted'
        break
      case 'Refund':
        s = 'Refund'
        break
      case 'Cancel':
        s = 'Transaction Close'
        break
      case 'Init':
        s = 'To Pay'
        break
      case 'Invalid':
        s = 'Payment Timeout'
        break
      default:
        s = status
        break
    }
    return s
  }
})
